<template>
  <div class="default-data-table px-3">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      class="elevation-0 mt-2"
      :no-data-text="noDataText"
      hide-actions
    >
      <template v-slot:items="props">
        <slot
          name="items"
          :item="props.item"
          :index="props.index"
          :selected="props.selected"
          :expanded="props.expanded"
        >
        </slot>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'DefaultDataTable',
  props: {
    headers: {
      type: Array,
      default: []
    },
    items: {
      type: Array,
      default: []
    },
    loading: {
      type: Boolean,
      default: false
    },
    noDataText: {
      type: String,
      default: ''
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    }
  }
}
</script>

<style>

.default-data-table {
  background-color: white;
}

.default-data-table table thead th {
  font-family: 'Paralucent' !important;
  color: #44517B !important;
}

.default-data-table table tbody td {
  font-family: 'Paralucent' !important;
  color: #858EA1 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/DefaultDataTable.vue